module TaskList {
    export interface IImportResultController {
        handleImportResult(result);
    }

    export interface ImportResultHandlerFunc {
        (result: any, file: any): void
    }

    export class ImportController {
        public resultHandler: ImportResultHandlerFunc;

        public uploadFile(file: any, uploadUrl: string) {
            if (file.files == null || file.files.length == 0) {
                return; // the file was cleared or not set
            }

            var formData = new FormData();
            var fileToUpload = file.files[0];
            formData.append("file", fileToUpload);

            /**
            https://uncorkedstudios.com/blog/multipartformdata-file-upload-with-angularjs

            Angular’s default transformRequest function will try to serialize our FormData object, 
            so we override it with the identity function to leave the data intact. 
            Angular’s default Content-Type header for POST and PUT requests is application/json, 
            so we want to change this, too. By setting ‘Content-Type’: undefined, 
            the browser sets the Content-Type to multipart/form-data for us and fills in the correct boundary. 
            Manually setting ‘Content-Type’: multipart/form-data will fail to fill in the boundary parameter of the request. 
            **/

            this.$http.post(uploadUrl, formData,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                })
                .then(
                (data: JsonResult) => {
                    if (data.data.success) {
                        this.resultHandler(data.data.data, file);
                    }
                });
        }

        constructor(private $http: ng.IHttpService, private notification: INotifications) {

        }
    }
    app.controller("importController", ["$http", "notifications", ImportController]);
}